module.exports = __webpack_public_path__ + "static/media/judgement_hammer.069a7caa.png";